import { render } from "./FileManagerOptions.vue?vue&type=template&id=cc2c442c"
import script from "./FileManagerOptions.vue?vue&type=script&lang=js"
export * from "./FileManagerOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__